import http from '@/plugins/axios_plugin';

class ServiceRepresentantes {

    index (representante_id) {
        return http.get('/api/representantes/config/listar?id=' + representante_id)
    }

    salvarConfig(representante) {
        return http.post('/api/representantes/config/salvar', representante)
    }

    listarFornecedores (representante_id) {
        return http.get('/api/representantes/'+ representante_id + '/fornecedores')
    }



    listar () {
        return http.get('/api/representantes/listar');
    }

    salvar (representante) {
        return http.post('/api/representantes/salvar', representante);
    }

    editar (representante_id) {
        return http.get('/api/representantes/' + representante_id + '/editar');
    }

    atualizar (representante) {
        return http.post('/api/representantes/' + representante.id + '/atualizar', representante);
    }

    excluir (representante_id) {
        return http.post('/api/representantes/' + representante_id + '/excluir');
    }

    resetarSenha (representante_id) {
        return http.post('/api/representantes/' + representante_id + '/resetar');
    }

    ativarDesativarFornecedor (representante_id, fornecedor_id, status) {
        let post = {
            'status': status
        };
        return http.post('/api/representantes/' + representante_id + '/fornecedor/'  + fornecedor_id + '/ativacao', post);
    }

}

export default new ServiceRepresentantes();